<template>
  <div>
    <b-table-filter
      :items="rows"
      :fields="fields"
      title="Báo Cáo Học Sinh/Phụ Huynh"
      :perPage="perPage"
      :pageLength="pageLength"
      :isBusy="busy"
      :totalRows="totalRow"
    >
      <!-- <template #rightAction>
        <div>
          <b-button size="sm" variant="info"><feather-icon icon="CalendarIcon" /> Hôm Nay</b-button>
          <b-button size="sm"  variant="success"><feather-icon icon="CalendarIcon" /> Tuần Này</b-button>
          <b-button size="sm" variant="warning"><feather-icon icon="CalendarIcon" /> Tháng Này</b-button>
          <b-button size="sm"><feather-icon icon="CalendarIcon" /> Tháng Trước</b-button>
        </div>
      </template> -->
      <template #filterTable>
        <td style="width: 15%">
          <b-form-datepicker placeholder="Từ Ngày" v-model="fromDate" size="sm" />
        </td>
        <td style="width: 15%">
          <b-form-datepicker placeholder="Đến Ngày" v-model="toDate" size="sm" />
        </td>
        <td style="width: 15%">
          <vue-select class="select-size-sm" placeholder="Tình Trạng Thanh Toán" :options="[{value: 'tra_du', label: 'Trả Đủ'},{value: 'can_thanh_toan', label: 'Cần Thanh Toán'},]" />
        </td>
        <td style="width: 15%">
          <vue-select class="select-size-sm" placeholder="Tình Trạng Đăng Ký" :options="[{value: 'tra_du', label: 'Đã Xác Nhận'},{value: 'can_thanh_toan', label: 'Chưa Xác Nhận'},]" />
        </td>
        <td>
          Nếu không chọn Ngày Sẽ Lấy 5 ngày gần Nhất
        </td>
        <td>
          <div style="float:right">
            <b-button variant="warning" size="sm" @click="onSubmitFilter" style="margin-right: 5px"><feather-icon icon="SearchIcon" /> Xem Báo Cáo</b-button>
          </div>
        </td>
      </template>
    </b-table-filter>
  </div>
</template>

<script>
import {
  BFormDatepicker, BButton, 
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VueSelect from 'vue-select'
import BTableFilter from '@/@core/components/datatable/BTableFilter.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    VueSelect,
    BFormDatepicker,
    BButton,
    BTableFilter,
    FeatherIcon,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      busy: false,
      totalRow: 1,
      pageLength: 10,
      dir: false,
      fields: [
        {
          label: 'STT',
          key: 'id',
        },
        {
          label: 'Họ Tên Phụ Huynh',
          key: 'fullName',
        },
        {
          label: 'Điện Thoại Khách Hàng',
          key: 'phone',
        },
        {
          label: 'Số Học Học Viên/Phụ Huynh',
          key: 'paid',
        },
        {
          label: 'Tình Trạng',
          key: 'status',
        },
        {
          label: 'Ghi Chú 1',
          key: 'note1',
        },
      ],
      rows: [],
      fromDate: null,
      toDate: null,
    }
  },
  computed: {
  },
  methods: {
    onSubmitFilter() {
      this.busy = false
      console.log('onSubmitFilter', this.fromDate, this.toDate)
      this.rows = [
        {
          id: 1,
          fullName: 'Danh Sinh',
          phone: '096-998-5002',
          paid: 2,
          courseCount: 10,
          status: 'Đã Học',
          note1: 'AOIWDJAJWDJA ',
          note2: 'ĂDAWDAWDAWDA',
        },
        {
          id: 1,
          fullName: 'Danh Sinh',
          phone: '096-998-5002',
          paid: 1,
          courseCount: 10,
          status: 'Đã Đăng Ký',
          note1: 'AOIWDJAJWDJA ',
          note2: 'ĂDAWDAWDAWDA',
        },
      ]
    },
    onReset() {
      this.fromDate = null
      this.toDate = null
    },
  },
}
</script>
